import {
  CustomFieldControl,
  DefaultFormFields,
  DynamicFormController,
  FormControl,
} from '@insurancemenu/imenu-components-lib/dist/utils/forms';
import { ReplicatedInfoDelegate, ReplicatedInfoItem } from '../replicatedInfoDelegate';

export interface DDARAuthorizedAgent extends ReplicatedInfoItem {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  userName?: string;
}

export interface AuthorizedAgentFormFields extends DefaultFormFields {
  firstName: FormControl<string>;
  lastName: FormControl<string>;
  email: FormControl<string>;
  userName: FormControl<string>;
}

type ExpectedDynamicController = DynamicFormController<{
  ddarAuthorizedAgents: CustomFieldControl<DDARAuthorizedAgent[]>;
}>;

export class DDARAuthorizedAgentsDelegate {
  private _dynamicFormController: ExpectedDynamicController;

  public replicatedInfoDelegate: ReplicatedInfoDelegate<DDARAuthorizedAgent, AuthorizedAgentFormFields>;

  constructor(dynamicFormController: ExpectedDynamicController) {
    this._dynamicFormController = dynamicFormController;
    this.replicatedInfoDelegate = new ReplicatedInfoDelegate<DDARAuthorizedAgent, AuthorizedAgentFormFields>({
      itemFormFields: {
        firstName: new FormControl<string>('', { validations: ['validName'] }),
        lastName: new FormControl<string>('', { validations: ['validName'] }),
        email: new FormControl<string>('', { validations: ['isEmailValid'] }),
        userName: new FormControl<string>('', { validations: ['printableCharacters'], optional: true }),
      },
      syncItemsValue: (items: DDARAuthorizedAgent[]): void => {
        this._dynamicFormController.populateCustomFields({
          ddarAuthorizedAgents: items,
        });
      },
      maxItems: 3,
    });

    const authorizedAgents = this._dynamicFormController.getCustomFormFieldsObject().ddarAuthorizedAgents ?? [];
    this.replicatedInfoDelegate.populateItems(authorizedAgents as DDARAuthorizedAgent[]);
  }
}
